import {testIds} from '@dms/routes';
import {DmsDataGrid, PersonnelOverview, PersonnelOverviewWrapper} from '@dms/shared';

import {useBusinessCasesActionCallback} from '../../hooks/useBusinessCasesActionCallback';
import {businessCaseBulkOperationActionCallback} from '../../utils/businessCaseBulkOperationActionCallback';

const BUSINESS_CASE_PERSONNEL_OVERVIEW_FILTER_ID = 'business-case-personnel-overview-filter';
const GRID_CODE = 'business-case';
interface BusinessCaseListProps {
  isPersonnelPanelOpen: boolean;
  canViewBusinessCase: boolean;
}

export function BusinessCaseList(props: BusinessCaseListProps) {
  const [actionCallback] = useBusinessCasesActionCallback();
  const isPersonnelOverviewOpen = props.isPersonnelPanelOpen && props.canViewBusinessCase;

  return (
    <PersonnelOverviewWrapper
      externalFilterId={
        isPersonnelOverviewOpen ? BUSINESS_CASE_PERSONNEL_OVERVIEW_FILTER_ID : undefined
      }
      data-testid={testIds.businessCase.home('personnelOverviewWrapper')}
    >
      <DmsDataGrid
        gridCode={GRID_CODE}
        actionCallback={actionCallback}
        bulkOperationActionCallback={businessCaseBulkOperationActionCallback}
        data-testid={testIds.businessCase.home('bussinessCaseList')}
        externalFilterId={BUSINESS_CASE_PERSONNEL_OVERVIEW_FILTER_ID}
        filterComponent={(connectorProps) => (
          <PersonnelOverview
            entity={GRID_CODE}
            isOpen={isPersonnelOverviewOpen}
            values={connectorProps.values}
            onChange={connectorProps.onChange}
            data-testid={testIds.businessCase.home('personnelOverview')}
          />
        )}
      />
    </PersonnelOverviewWrapper>
  );
}
